module.exports = __webpack_public_path__ + "static/media/features-split-image-02.d2271dd4.png";